/* eslint-disable react/display-name */
import React, { ReactText } from 'react';

import BodyText from '../../../BodyText';
import Heading from '../../../Heading';
import Box from '../../../Box';

export interface TooltipProps {
  /**
   * Tooltip title
   */
  title?: string;
  /**
   * Tooltip message
   */
  message: ReactText;
}

/**
- The Tooltip Text component allows to easily display informative text when users hover over, focus on, or tap an element.
**/
const Text = ({ title, message }: TooltipProps) => {
  return (
    <>
      {title && (
        <Box marginBottom={5}>
          <Heading variant="h6" color="inherit">
            {title}
          </Heading>
        </Box>
      )}
      <BodyText variant="body3" color="inherit">
        {message}
      </BodyText>
    </>
  );
};

export default Text;
